import "./assets/scss/Theme.scss";

import { useEffect } from "react";
import { getPortalType } from "./apps/common/helpers";
import { PortalTypes } from "./constants/portals";
import { useAuthStore } from "./apps/common/store/useAuthStore";
import RoutesHandler, {
  RoutesHandlerProps
} from "./apps/common/components/RoutesHandler";
import { useRequest } from "ahooks";
import { Spinner } from "react-bootstrap";
import { api } from "@/apps/common/api-client";

const clinicalRoutesParams = import("./apps/clinic/routes");
const memberRoutesParams = import("./apps/member/routes");
const providerRoutesParams = import("./apps/provider/routes");
const adminRoutesParams = import("./apps/admin/routes");

export default function App() {
  const portalType = getPortalType();

  const { data: params, loading } = useRequest(() => {
    let params: Promise<RoutesHandlerProps> = memberRoutesParams;

    if (portalType == PortalTypes.CLINICAL) {
      params = clinicalRoutesParams;
    } else if (portalType == PortalTypes.PROVIDER) {
      params = providerRoutesParams;
    } else if (portalType == PortalTypes.ADMIN) {
      params = adminRoutesParams;
    } else if (portalType == PortalTypes.PARTNER) {
      params = clinicalRoutesParams;
    }

    return params;
  });

  const { fetchUser, user } = useAuthStore();

  const fetchUserSettings = async () => {

    //console.debug(`user - ${JSON.stringify(user)}`)

    const _user: any = user

    if (user && _user?.["role"]?.["name"] === "Member") {
      const userSettings = await api.userSettings.getByUserId(user?.id)
      //console.debug(`userSettings - ${JSON.stringify(userSettings)}`)
      if (userSettings?.tags && userSettings.newTags) {
        sessionStorage.setItem("newTags", "New Sessions")
      }
    }
  }

  const { data: userSettings, runAsync: _fetchUserSettings } = useRequest(
    fetchUserSettings
    , {
      pollingInterval: 15000,
      refreshDeps: [user]
    })

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  useEffect(() => {
    //console.debug (`user - ${JSON.stringify(user)}`)
    _fetchUserSettings()
  }, [user]);

  if (loading || !params) {
    return <Spinner animation="border" role="status" />;
  }

  return <RoutesHandler {...params} />;
}
